// extracted by mini-css-extract-plugin
export default {"canvas":"LineChart_canvas__SFVD4"};